import { apiClient } from "shared/api/client";
import { alertDialog } from "shared/ui/feedback";

export const UpdateUserInfo = async (id, updatedData) => {
  try {
    const response = await apiClient.put(`/appUsers/${id}`, updatedData);
    return response.data;
  } catch (error) {
    alertDialog("에러발견");
    // console.error("Error:", error);
  }
};

export const PatchUserInfo = async (name, department, position) => {
  const data = {
    name: name,
    department: department,
    position: position,
  };

  try {
    // 페이지를 새로고침하지 않고 응답만 돌려준다.
    // 호출부(프로필 모달)가 로컬 state와 react-query 캐시를 직접 갱신한다.
    const response = await apiClient.patch(`/appUsers/updateProfile`, data);
    return response.data;
  } catch (error) {
    // console.error("Error in postInquiries:", error);
    throw error;
  }
};
